import { render, staticRenderFns } from "./NavigationLink.vue?vue&type=template&id=125b146e&scoped=true&"
import script from "./NavigationLink.vue?vue&type=script&lang=js&"
export * from "./NavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLink.vue?vue&type=style&index=0&id=125b146e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b146e",
  null
  
)

export default component.exports